const STORAGE_KEY = "ouro-explicit-logout";

function getLocalStorage() {
  try {
    if (typeof localStorage === "undefined") {
      return null;
    }
    return localStorage;
  } catch {
    return null;
  }
}

export function markExplicitLogout() {
  const storage = getLocalStorage();
  try {
    storage?.setItem(STORAGE_KEY, "1");
  } catch {
    // localStorage may be unavailable.
  }
}

export function clearExplicitLogout() {
  const storage = getLocalStorage();
  try {
    storage?.removeItem(STORAGE_KEY);
  } catch {
    // localStorage may be unavailable.
  }
}

export function hasExplicitLogout() {
  const storage = getLocalStorage();
  try {
    return storage?.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export const EXPLICIT_LOGOUT_STORAGE_KEY = STORAGE_KEY;
